import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/' },
    { name: '恋爱漫画', path: '/category/romance' },
    { name: '奇幻漫画', path: '/category/fantasy' },
    { name: '动作漫画', path: '/category/action' },
    { name: '悬疑漫画', path: '/category/mystery' },
    { name: '搞笑漫画', path: '/category/comedy' },
  ],
  about: [
    { name: '关于我们', path: '/about' },
    { name: '用户协议', path: '/about' },
    { name: '隐私政策', path: '/about' },
    { name: '版权声明', path: '/about' },
  ],
  contact: {
    email: 'contact@xiangxiangmanhua.com',
    wechat: '香香漫画',
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl text-primary-500 tracking-wide">
              香香漫画
            </Link>
            <p className="text-foreground-500 text-sm mt-3 leading-relaxed">
              海量韩漫免费阅读平台，韩漫全集下拉式畅读，最新韩漫追更，好看漫画一网打尽。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-800 font-semibold text-sm mb-4">热门分类</h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-foreground-500 text-sm hover:text-primary-500 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-800 font-semibold text-sm mb-4">关于</h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-foreground-500 text-sm hover:text-primary-500 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-800 font-semibold text-sm mb-4">联系我们</h4>
            <ul className="space-y-2 text-foreground-500 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>{footerLinks.contact.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-base"></i>
                <span>微信：{footerLinks.contact.wechat}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 香香漫画 - 韩漫免费阅读平台。本站内容仅供学习交流，请勿用于商业用途。
          </p>
          <p className="text-foreground-500 text-xs">
            备案号：京ICP备2024000001号-1
          </p>
        </div>
      </div>
    </footer>
  );
}